export const containsNonNumericCharacter = (value: string) => /[^0-9,.-]/.test(value)
